export default __webpack_public_path__ + "static/media/purple-kettle-bell.82be1d46.jpg";